import { TooltipState, BaseTooltipAction } from '../types';

type MerchantAccessTooltipAction = BaseTooltipAction | 'conflict';

export const merchantAccessTooltipReducer = (
    state: TooltipState,
    action: MerchantAccessTooltipAction,
): TooltipState => {
    switch (action) {
        case 'error':
            return {
                tooltipVisible: true,
                tooltipTheme: 'error',
                tooltipLabel: 'Произошла ошибка',
            };
        case 'ok':
            return {
                tooltipVisible: true,
                tooltipTheme: 'success',
                tooltipLabel: 'Запрос отправлен',
            };
        case 'conflict':
            return {
                tooltipVisible: true,
                tooltipTheme: 'error',
                tooltipLabel: 'Доступ уже запрошен',
            };
        case 'clear':
            return {
                tooltipVisible: false,
            };
    }
};

type EnableBillingTooltipActionn = 'clear' | 'error';

export const enableBillingTooltipReducer = (state: TooltipState, action: EnableBillingTooltipActionn): TooltipState => {
    switch (action) {
        case 'error':
            return {
                tooltipVisible: true,
                tooltipTheme: 'error',
                tooltipLabel: 'Произошла ошибка',
            };
        case 'clear':
            return {
                tooltipVisible: false,
            };
    }
};
